import React, { useEffect, useState } from 'react';
import {
  clearEvents,
  disable,
  formatEvents,
  getEvents,
  isEnabled,
  subscribe,
} from '../lib/debugBus';

const overlayStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 2147483647,
  background: 'rgba(0,0,0,0.92)',
  color: '#9CFF9C',
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  fontSize: 11,
  padding: '6px 8px',
  borderTop: '1px solid #444',
  maxHeight: '45vh',
  overflowY: 'auto',
  WebkitTouchCallout: 'auto',
  WebkitUserSelect: 'text',
  userSelect: 'text',
};

const btnStyle = {
  background: '#1f1f1f',
  color: '#fff',
  border: '1px solid #555',
  borderRadius: 4,
  padding: '4px 8px',
  fontSize: 11,
  marginRight: 6,
};

const DebugOverlay = () => {
  const [, force] = useState(0);
  const [open, setOpen] = useState(true);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setEnabled(isEnabled());
    const unsub = subscribe(() => force((x) => x + 1));
    return unsub;
  }, []);

  if (!enabled) return null;

  const events = getEvents();
  const text = formatEvents();

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      alert('Log copiato negli appunti. Incollalo in chat.');
    } catch {
      window.prompt('Copia manualmente questo log:', text);
    }
  };

  return (
    <div style={overlayStyle}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
        <button style={btnStyle} onClick={() => setOpen((o) => !o)}>
          {open ? 'nascondi' : 'mostra'}
        </button>
        <button style={btnStyle} onClick={copy}>copia log</button>
        <button style={btnStyle} onClick={clearEvents}>reset</button>
        <button
          style={btnStyle}
          onClick={() => {
            disable();
            const u = new URL(window.location.href);
            u.searchParams.delete('debug');
            window.location.replace(u.toString());
          }}
        >
          off
        </button>
        <span style={{ color: '#aaa' }}>eventi: {events.length}</span>
      </div>
      {open && (
        <pre style={{ whiteSpace: 'pre-wrap', margin: 0, marginTop: 4 }}>{text || 'in attesa di eventi...'}</pre>
      )}
    </div>
  );
};

export default DebugOverlay;
